import axios from "axios"
//const baseUrl = "http://localhost/spacs31/api/Appointment/";
const baseUrl = "https://drcemyilmaz.simplexbt.com/api/api/Appointment/";
const toastLife = 5000;

const moment = require('moment');

class Common {
    constructor() {

        this.FormatDateTime2 = function (dateTime, isOnlyDate = false, isOnlyTime = false) {
            var result = moment(dateTime).format('DD.MM.YYYY HH:mm:ss')
            //var result = new Date(dateTime).toLocaleString("tr-TR");
            if (result == "Invalid Date") {
                result = "Geçersiz Zaman";
            }
            else if (isOnlyDate) {
                result = result.split(" ")[0];
            }
            else if (isOnlyTime) {
                result = result.split(" ")[1];
            }
            if (result == "01.01.1970") {
                result = "";
            }
            return result;
        }

        this.FormatDateTime = function (datetime, isDate = true, isTime = true) {
            if (isDate && isTime)
                return new Date(datetime).toLocaleDateString() + " " + new Date(datetime).toLocaleTimeString();
            else if (isTime)
                return new Date(datetime).toLocaleTimeString();
            else if (isDate)
                return new Date(datetime).toLocaleDateString();
        }

        this.AxiosGet = function (url, data = null, okFunc = null, errorFunc = null, isInfo = false) {
            if (isInfo)
                window.toastObj.add({ severity: 'info', summary: 'Bilgi', detail: 'İşlem devam ediyor.', life: toastLife });

            axios.get(baseUrl + url, { params: data })
                .then(res => {
                    if (isInfo && res.status == 200)
                        window.toastObj.add({ severity: 'success', summary: 'Bilgi', detail: 'İşlem başarıyla sonuçlanmıştır.', life: toastLife });
                    else if (res.status != 200) {
                        window.toastObj.add({ severity: 'success', summary: 'Warning', detail: res.data, life: toastLife });
                    }
                    if (okFunc != null) {
                        okFunc(res.data, res);
                    }
                }).catch(err => {
                    if (isInfo)
                        window.toastObj.add({ severity: 'error', summary: 'Bilgi', detail: 'İşlem sırasında bir hata meydana geldi.\n' + err, life: toastLife });
                    if (errorFunc != null) {
                        errorFunc(err);
                    }
                });
        }

        this.AxiosPost = function (url, data = null, okFunc = null, errorFunc = null, isInfo = false) {
            common.Loading.Open();

            if (isInfo)
                window.toastObj.add({ severity: 'info', summary: 'Bilgi', detail: 'İşlem devam ediyor.', life: toastLife });

            axios.post(baseUrl + url, data)
                .then(res => {
                    if (isInfo && res.status == 200)
                        window.toastObj.add({ severity: 'success', summary: 'Bilgi', detail: 'İşlem başarıyla sonuçlanmıştır.', life: toastLife });
                    else if (res.status != 200) {
                        window.toastObj.add({ severity: 'success', summary: 'Warning', detail: res.data, life: toastLife });
                    }
                    if (okFunc != null) {
                        okFunc(res.data, res);
                    }
                    common.Loading.Close();
                }).catch(err => {
                    if (err.response.status == 404) {
                        window.toastObj.add({ severity: 'error', summary: 'Bilgi', detail: 'İşlem sırasında bir hata meydana geldi.\n' + err.response.data, life: toastLife });
                    }

                    if (errorFunc != null) {
                        errorFunc(err);
                    }
                    common.Loading.Close();
                });
        }

        this.Toast = function (obj) {
            window.toastObj.add(obj);
        }

        this.Loading = {
            Open: () => {
                document.getElementById("screen-loading").classList.remove("hide");
            },
            Close: () => {
                document.getElementById("screen-loading").classList.add("hide");
            }
        }
    }
}

var common = new Common();
export { common };